import { ConnectComponent } from '../../../_components/ConnectComponent'
import { PolicyTablePresenter } from './PolicyTable.presenter'
import { PolicyTableView } from './PolicyTable.view'

export const PolicyTable = ConnectComponent(
  PolicyTableView,
  PolicyTablePresenter,
)
